import { render, staticRenderFns } from "./AppBarChart.vue?vue&type=template&id=487bb0e7&scoped=true"
import script from "./AppBarChart.vue?vue&type=script&lang=js"
export * from "./AppBarChart.vue?vue&type=script&lang=js"
import style0 from "./AppBarChart.vue?vue&type=style&index=0&id=487bb0e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487bb0e7",
  null
  
)

export default component.exports